import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { Tabs, Button } from '@components';
import { useSelector } from 'react-redux';
import {
  CONTRATOS_ABSOLUTE_PATH,
  SIMULADOR_ABSOLUTE_PATH,
} from '../../common/utils/paths';

export const EmprestimosPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { simular_emprestimo: showSimular, contratos_aberto: showContratos } =
    useSelector((state) => state.telasDisponiveis);

  useEffect(() => {
    if (location.pathname.includes('simulador') && showSimular) {
      navigate(SIMULADOR_ABSOLUTE_PATH);
    }
    if (location.pathname.includes('contratos') && showContratos) {
      navigate(CONTRATOS_ABSOLUTE_PATH);
    } else if (showSimular) {
      navigate(SIMULADOR_ABSOLUTE_PATH);
    } else if (showContratos) {
      navigate(CONTRATOS_ABSOLUTE_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSimular, showContratos]);

  const activeTab = () => {
    if (location.pathname.includes('simulador')) return 'Simular e contratar';
    if (location.pathname.includes('contratos')) return 'Contratos em aberto';
    if (showSimular) return 'Simular e contratar';
    if (showContratos) return 'Contratos em aberto';
    return '';
  };

  return (
    <>
      <Helmet>
        <title>Forluz - Empréstimos</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2 mb-md-2">Empréstimos</h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() =>
            navigate(location.pathname.includes('simulador') ? -2 : -1)
          }
        >
          Voltar
        </Button>
      </div>
      <Tabs active={activeTab()}>
        {showSimular && (
          <div
            label="Simular e contratar"
            onClick={() => navigate(SIMULADOR_ABSOLUTE_PATH)}
            aria-hidden
          >
            <Outlet />
          </div>
        )}

        {showContratos && (
          <div
            label="Contratos em aberto"
            onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
            aria-hidden
          >
            <Outlet />
          </div>
        )}
      </Tabs>
    </>
  );
};
